export function isInputFromScan(cur: string, prev: string) {
  return cur.length - 1 > prev.length;
}
